import React, { useState } from "react";
import "./Sidebarpo.css";
import { Link, useLocation } from "react-router-dom";

// Normal icons
import dashboord from '../assets/images/sidebaricon.png';
import dashboord1 from '../assets/images/sidebaricon1.png';
import dashboord2 from '../assets/images/sidebaricon2.png';
import dashboord3 from '../assets/images/sidebaricon3.png';
import dashboord4 from '../assets/images/sidebaricon4.png';
import dashboord5 from '../assets/images/sidebaricon5.png';
import dashboord6 from '../assets/images/sidebaricon6.png';

import hover from '../assets/images/hovericon.png';
import hover1 from '../assets/images/hovericon1.png';
import hover2 from '../assets/images/hovericon2.png';
import hover3 from '../assets/images/hovericon3.png';
import hover4 from '../assets/images/hovericon4.png';
import hover5 from '../assets/images/hovericon5.png';
import hover6 from '../assets/images/hovericon6.png';
import logo from '../assets/images/WhatsApp Image 2025-08-14 at 7.05.00 PM.jpeg';

const Sidebarpo = () => {
  const [hovered, setHovered] = useState(null);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setIsMobileOpen(!isMobileOpen);
  const closeSidebar = () => setIsMobileOpen(false);

  const menuItems = [
    { path: "/dashboard", name: "Dashboard", icon: dashboord, hoverIcon: hover },
    { path: "/createpo", name: "Create New PO", icon: dashboord1, hoverIcon: hover1 },
    { path: "/listpo", name: "PO List", icon: dashboord2, hoverIcon: hover2 },
    { path: "/clientlist", name: "Client List", icon: dashboord3, hoverIcon: hover3 },
    { path: "/supplierpo", name: "Supplier List", icon: dashboord4, hoverIcon: hover4 },
    { path: "/customer", name: "POs by Customer", icon: dashboord5, hoverIcon: hover5 },
    { path: "/reports", name: "PO Reports", icon: dashboord6, hoverIcon: hover6 },
  ];

  return (
    <>
      <button className="sidebar-toggle d-md-none" onClick={toggleSidebar}>☰</button>
      <div className={`sidebar-wrapper ${isMobileOpen ? "open" : ""}`}>
        <div className="sidebar p-4">
          <button className="close-btn d-md-none" onClick={closeSidebar}>✕</button>
          {/* <h6 className="sidebarheding mt-4">BI <span>Manager</span></h6> */}
          <h6 className="sidebarheding mt-4">
                      <img src={logo}
            style={{width:'140px'}}

                      />
                    </h6>
          <ul className="list-unstyled mt-5">
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              const isHovering = hovered === index;

              return (
                <li
                  key={index}
                  className={`nav-item mb-2 ${isActive ? "active" : ""}`}
                  onMouseEnter={() => setHovered(index)}
                  onMouseLeave={() => setHovered(null)}
                >
                  <Link className="nav-link d-flex align-items-center" to={item.path}>
                    <img
                      src={isHovering || isActive ? item.hoverIcon : item.icon}
                      alt={item.name}
                      className="me-2"
                      style={{ width: "24px", height: "24px" }}
                    />
                    <span className={`ml-3 ${isHovering ? "text-hover" : ""}`}>{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebarpo;
